enum API {
	GET_USER_CONNECTIONS = '/api/chat/getUserConnections',
	SEARCH_CONNECTIONS = '/api/chat/searchConnections',
	GET_ROOM_MEMBERS = '/api/chat/getRoomMembers'
}

export default API;
